export default "__VITE_ASSET__DI3Vxm_S__"